import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ISystemTransactionsFields } from '~/models/modules/Common/systemTransactionsFieldsDto';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class SystemTransactionsFieldsService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.common);
  }

  getFieldByObjectCode(objectCode:string, pageName:string){
    return this.client.get<ISystemTransactionsFields[]>(this._url(`/getByObjectCode/${objectCode}/${pageName}`));
  }

  getFieldsByPageName(pageName:string){
    return this.client.get<ISystemTransactionsFields[]>(this._url(`/getByPage/${pageName}`));
  }

  getFieldsByTransaction(transactionId:number){
    return this.client.get<ISystemTransactionsFields[]>(this._url(`/getByTransaction/${transactionId}`));
  }

  createFieldRange(model: ISystemTransactionsFields[]){
    return this.client.post<boolean>(this._url(`/create-range`), model);
  }

  create(model: ISystemTransactionsFields){
    return this.client.post<ISystemTransactionsFields>(this._url(`/create`), model);
  }

  update(model: ISystemTransactionsFields){
    return this.client.post<ISystemTransactionsFields>(this._url(`/update`), model);
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/SystemTransactionsFields${v}`);
  }
}
